export const LEVELS = {
  level1: {
  },
  level2: {
  }
}

export const CONSTANTS = {
}
